"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseChromeStyleId = exports.generateListedPriceOrMSRP = exports.shouldCallApi = exports.getListOfSatisfiedVehicleProps = exports.getFuelEconomy = exports.vcdaToVehicle = exports.cviToVehicle = exports.DealExchangeValidator = exports.toString = exports.satisfyProperties = void 0;
exports.satisfyProperties = {
    vcda: [
        'bodyStyle',
        'cityFuelEconomy',
        'cost',
        'driveLine',
        'engine',
        'engineSize',
        'exteriorColor',
        'exteriorColorFull',
        'fuel',
        'highwayFuelEconomy',
        'interiorColor',
        'interiorColorFull',
        'interiorMaterial',
        'inventoryDate',
        'invoiceAmount',
        'mileage',
        'stockNumber',
        'styleId',
        'transmission',
        'trim'
    ],
    cvi: [
        'bodyStyle',
        'cityFuelEconomy',
        'condition',
        'cost',
        'destinationCharge',
        'driveLine',
        'engine',
        'engineSize',
        'exteriorColor',
        'exteriorColorFull',
        'fuel',
        'highwayFuelEconomy',
        'imageUrl',
        'interiorColor',
        'interiorColorFull',
        'interiorMaterial',
        'inventoryDate',
        'invoiceAmount',
        'listedPrice',
        'location',
        'make',
        'mileage',
        'model',
        'retailPrice',
        'stockNumber',
        'styleId',
        'transmission',
        'trim',
        'vin',
        'year'
    ]
};
var AcceptedEnums = {
    condition: {
        map: {
            new: 'New',
            used: 'Used',
            demo: 'Demo',
            certifiedpreowned: 'CertifiedPreOwned',
            rental: 'Rental',
            consignment: 'Consignment',
            other: 'Other'
        },
        default: 'Used'
    },
    drivetrainType: {
        match: [
            {
                value: 'AllWheelDrive',
                test: function (value) { return /all.?wheel(.?drive)?/i.test(value) || /awd/i.test(value); }
            },
            {
                value: 'FourWheelDrive',
                test: function (value) { return /(four|4).?wheel(.?drive)?/i.test(value) || /(4wd|4.4)/i.test(value); }
            },
            {
                value: 'FrontWheelDrive',
                test: function (value) { return /front.?wheel(.?drive)?/i.test(value) || /(fwd|2.4)/i.test(value); }
            },
            {
                value: 'RearWheelDrive',
                test: function (value) { return /rear.?wheel(.?drive)?/i.test(value) || /(rwd|4.2)/i.test(value); }
            }
        ]
    },
    fuelTypes: {
        match: [
            { value: 'Gasoline', test: function (value) { return /gasoline/i.test(value); } },
            { value: 'Diesel', test: function (value) { return /diesel/i.test(value); } },
            { value: 'Electric', test: function (value) { return /electr/i.test(value); } },
            { value: 'NaturalGas', test: function (value) { return /natural.?gas/i.test(value) || /cng/i.test(value); } },
            { value: 'Hydrogen', test: function (value) { return /hydro/i.test(value); } },
            { value: 'Other', test: function (value) { return /other/i.test(value); } }
        ]
    }
};
var toString = function (value) {
    var valueType = typeof value;
    if (valueType === 'string' || valueType === 'number')
        return String(value);
    return undefined;
};
exports.toString = toString;
exports.DealExchangeValidator = {
    condition: function (value) {
        if (!value)
            return AcceptedEnums.condition.default;
        return AcceptedEnums.condition.map[value.toLowerCase()] || AcceptedEnums.condition.default;
    },
    fuel: function (value) {
        if (typeof value !== 'string' || value === '')
            return [];
        var Result = [];
        AcceptedEnums.fuelTypes.match.forEach(function (T) {
            if (T.test(value)) {
                Result.push(T.value);
            }
        });
        return Result;
    },
    driveLine: function (value) {
        if (typeof value !== 'string' || value === '')
            return;
        var match = AcceptedEnums.drivetrainType.match;
        for (var i = 0; i < match.length; i++) {
            if (match[i].test(value)) {
                return match[i].value;
            }
        }
        return;
    }
};
var cviToVehicle = function (data, satisfied, noUndefined) {
    var _a;
    if (noUndefined === void 0) { noUndefined = false; }
    var condition = exports.DealExchangeValidator.condition(data.condition);
    var converted = {
        bodyStyle: data.bodyStyle,
        cityFuelEconomy: data.cityFuelEconomy,
        condition: condition,
        cost: data.wholesalePrice,
        destinationCharge: data.destinationCharge,
        driveLine: exports.DealExchangeValidator.driveLine(data.driveLine),
        engine: data.engine,
        engineSize: data.engineSize,
        exteriorColor: data.exteriorColor,
        exteriorColorFull: data.exteriorColorFull,
        fuel: exports.DealExchangeValidator.fuel(data.fuel)[0],
        highwayFuelEconomy: data.highwayFuelEconomy,
        imageUrl: data.imageUrl,
        initialRetailPrice: data.listedPrice,
        interiorColor: data.interiorColor,
        interiorColorFull: data.interiorColorFull,
        interiorMaterial: Array.isArray(data.interiorMaterial) ? data.interiorMaterial.join(', ') : data.interiorMaterial,
        inventoryDate: data.inventoryDate,
        invoiceAmount: data.invoicePrice,
        listedPrice: data.listedPrice,
        location: data.location,
        make: data.make,
        mileage: data.odometer,
        model: data.model,
        notes: data.sellerComments,
        // options is an empty array because in acceleron it's also mapped as an empty-
        // -array this should change if we change it in acceleron
        options: [],
        retailPrice: data.retailPrice,
        stockNumber: data.stockNumber,
        styleId: (0, exports.toString)(data.chromeId),
        transmission: ((_a = data.transmissionFull) === null || _a === void 0 ? void 0 : _a.primaryDescription) || data.transmission,
        trim: data.trim,
        type: condition.toLowerCase(),
        // vehicleId: we overwrite this field because it's a uuid from previous vehicle
        vehicleId: '',
        vin: data.vin,
        year: data.year
    };
    satisfied.forEach(function (key) {
        delete converted[key];
    });
    if (noUndefined) {
        Object.entries(converted).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value === undefined)
                delete converted[key];
        });
    }
    return converted;
};
exports.cviToVehicle = cviToVehicle;
var vcdaToVehicle = function (data, satisfied, noUndefined) {
    if (noUndefined === void 0) { noUndefined = false; }
    var converted = {
        bodyStyle: data.bodyStyle,
        cityFuelEconomy: data.cityFuelEconomy,
        cost: data.wholesalePrice,
        driveLine: exports.DealExchangeValidator.driveLine(data.driveLine),
        engine: data.engine,
        engineSize: data.engineSize,
        exteriorColor: data.exteriorColor,
        exteriorColorFull: data.exteriorColorFull,
        fuel: exports.DealExchangeValidator.fuel(data.fuel)[0],
        highwayFuelEconomy: data.highwayFuelEconomy,
        interiorColor: data.interiorColor,
        interiorColorFull: data.interiorColorFull,
        interiorMaterial: data.interiorMaterial,
        inventoryDate: data.inventoryDate,
        invoiceAmount: data.invoicePrice,
        mileage: data.odometer,
        stockNumber: data.stockNumber,
        styleId: (0, exports.toString)(data.chromeId),
        transmission: data.transmission,
        trim: data.trim
    };
    satisfied.forEach(function (key) {
        delete converted[key];
    });
    if (noUndefined) {
        Object.entries(converted).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (value === undefined)
                delete converted[key];
        });
    }
    return converted;
};
exports.vcdaToVehicle = vcdaToVehicle;
var getFuelEconomy = function (_a) {
    var cityFuelEconomy = _a.cityFuelEconomy, highwayFuelEconomy = _a.highwayFuelEconomy;
    var fuelEconomy = [];
    if (cityFuelEconomy) {
        fuelEconomy.push("".concat(Number(cityFuelEconomy).toFixed(1), " mpg City"));
    }
    if (highwayFuelEconomy) {
        fuelEconomy.push("".concat(Number(highwayFuelEconomy).toFixed(1), " mpg Highway"));
    }
    return fuelEconomy.join(' / ');
};
exports.getFuelEconomy = getFuelEconomy;
function getListOfSatisfiedVehicleProps(payload, origin) {
    return exports.satisfyProperties[origin].filter(function (prop) { return payload[prop] || payload[prop] === 0; });
}
exports.getListOfSatisfiedVehicleProps = getListOfSatisfiedVehicleProps;
var shouldCallApi = function (satisfiedFields, origin) {
    if (satisfiedFields.length < exports.satisfyProperties[origin].length)
        return true;
    for (var i = 0; i < exports.satisfyProperties[origin].length; i++) {
        if (!satisfiedFields.includes(exports.satisfyProperties[origin][i])) {
            return true;
        }
    }
    return false;
};
exports.shouldCallApi = shouldCallApi;
function generateListedPriceOrMSRP(offerType, vehicle, dealer) {
    var retailPrice;
    var vehicleCondition = vehicle.type || vehicle.condition || '';
    var vehicleConditionLowerCase = vehicleCondition.toLowerCase() || null;
    if (vehicleConditionLowerCase !== 'new') {
        return vehicle.listedPrice;
    }
    var isLeasePaymentOnMSRP = dealer.leaseSettings.isLeasePaymentOnMSRP;
    var isCashPaymentOnMSRP = dealer.cashOfferSettings.isCashPaymentOnMSRP;
    var isLeaseMSRP = offerType === 'lease' && isLeasePaymentOnMSRP;
    var isCashMSRP = offerType === 'cash' && isCashPaymentOnMSRP;
    var isListedPriceNotAvailable = !vehicle.listedPrice;
    if (isLeaseMSRP) {
        retailPrice = vehicle.retailPrice;
    }
    else if (isCashMSRP) {
        retailPrice = vehicle.retailPrice;
    }
    else if (isListedPriceNotAvailable) {
        retailPrice = vehicle.retailPrice;
    }
    else {
        retailPrice = vehicle.listedPrice;
    }
    return retailPrice;
}
exports.generateListedPriceOrMSRP = generateListedPriceOrMSRP;
var parseChromeStyleId = function (chromeStyleId) {
    if (!chromeStyleId) {
        return undefined;
    }
    var parsedId = Number(chromeStyleId);
    return isFinite(parsedId) ? parsedId : undefined;
};
exports.parseChromeStyleId = parseChromeStyleId;
